import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconBrandMicrosoftAzure(props: IconProps) {
  return (
    <BaseIcon size={40} {...props}>
      <defs>
        <linearGradient
          id="azure_grad0"
          x1="17.8839"
          y1="5.51405"
          x2="6.82087"
          y2="38.1971"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#114A8B" />
          <stop offset="1" stopColor="#0669BC" />
        </linearGradient>
        <linearGradient
          id="azure_grad1"
          x1="21.3396"
          y1="20.7453"
          x2="18.7805"
          y2="21.6106"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity="0.3" />
          <stop offset="0.071" stopOpacity="0.2" />
          <stop offset="0.321" stopOpacity="0.1" />
          <stop offset="0.623" stopOpacity="0.05" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="azure_grad2"
          x1="19.9326"
          y1="4.56082"
          x2="32.0766"
          y2="36.9145"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3CCBF4" />
          <stop offset="1" stopColor="#2892DF" />
        </linearGradient>
      </defs>
      <g transform="scale(0.6)">
        <path
          d="M14.0014 3.00041H24.6541L13.5955 35.7657C13.4819 36.1024 13.2655 36.395 12.9768 36.6022C12.6882 36.8095 12.3418 36.921 11.9864 36.9211H3.69601C3.42677 36.9211 3.16139 36.857 2.92183 36.7341C2.68226 36.6113 2.47541 36.4331 2.31836 36.2144C2.16132 35.9957 2.0586 35.7428 2.01871 35.4765C1.97883 35.2102 2.00291 34.9383 2.08898 34.6832L12.3919 4.15577C12.5055 3.81894 12.7219 3.52624 13.0106 3.3189C13.2994 3.11156 13.6459 3.00043 14.0014 3.00041Z"
          fill="url(#azure_grad0)"
        />
        <path
          d="M29.4815 24.9772H12.5888C12.4318 24.977 12.2783 25.0242 12.1485 25.1124C12.0186 25.2007 11.9183 25.3261 11.8607 25.4722C11.8031 25.6183 11.7908 25.7784 11.8254 25.9315C11.8601 26.0847 11.9401 26.2239 12.0549 26.331L22.9098 36.4625C23.2258 36.7573 23.6419 36.9212 24.0741 36.9211H33.6394L29.4815 24.9772Z"
          fill="#0078D4"
        />
        <path
          d="M14.0012 3.00044C13.6418 2.99906 13.2914 3.11262 13.0012 3.32453C12.711 3.53644 12.4961 3.83559 12.388 4.1783L2.10145 34.6554C2.00959 34.9114 1.98075 35.1858 2.01737 35.4554C2.05399 35.7249 2.15499 35.9817 2.31183 36.2039C2.46866 36.4262 2.67672 36.6074 2.9184 36.7322C3.16008 36.857 3.42828 36.9218 3.70029 36.9211H12.2047C12.5214 36.8645 12.8175 36.7249 13.0626 36.5164C13.3077 36.308 13.4931 36.0382 13.5998 35.7346L15.6511 29.6891L22.9785 36.5234C23.2856 36.7774 23.6707 36.9179 24.0692 36.9211H33.5989L29.4193 24.9772L17.2353 24.9801L24.6923 3.00044H14.0012Z"
          fill="url(#azure_grad1)"
        />
        <path
          d="M27.6077 4.15415C27.4943 3.81787 27.2782 3.52565 26.9899 3.31867C26.7016 3.1117 26.3556 3.00039 26.0007 3.00043H14.1284C14.4833 3.00045 14.8293 3.11178 15.1175 3.31875C15.4058 3.52572 15.6219 3.8179 15.7354 4.15415L26.0388 34.6828C26.1249 34.9379 26.149 35.2099 26.1092 35.4763C26.0693 35.7426 25.9666 35.9956 25.8096 36.2144C25.6525 36.4332 25.4457 36.6114 25.2061 36.7344C24.9665 36.8573 24.701 36.9215 24.4317 36.9215H36.3044C36.5737 36.9214 36.8391 36.8572 37.0786 36.7342C37.3182 36.6113 37.525 36.433 37.682 36.2143C37.839 35.9955 37.9417 35.7425 37.9815 35.4762C38.0213 35.2099 37.9972 34.9379 37.911 34.6828L27.6077 4.15415Z"
          fill="url(#azure_grad2)"
        />
      </g>
    </BaseIcon>
  );
}
